import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    List,
    ListItemButton,
    ListItemText,
    Typography,
    Button,
    CircularProgress,
    Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import useDataFetch from '../hooks/useDataFetch';
import { getFields, searchFields } from '../utils/fields';
import SearchForm from './SearchForm';
import Pagination from './Pagination';

const UserModal = ({ isOpen, onClose, onSelectUser }) => {
    const {
        dataset: users,
        loading,
        error,
        currentPage,
        totalPages,
        searchQuery,
        handleSearchChange,
        handleSearchSubmit,
        handleClearSearch,
        handlePageChange,
    } = useDataFetch('/users', {
        username: '',
        email: '',
        status: 'active',
    });

    const searchItems = getFields(searchFields, [
        'username',
        'email',
    ]);

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            fullWidth
            maxWidth="md"
        >
            <DialogTitle
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
            >
                担当者選択

                <IconButton onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                {/*<SearchForm
                    searchQuery={searchQuery}
                    searchFields={searchItems}
                    handleSearchChange={handleSearchChange}
                    handleSearchSubmit={handleSearchSubmit}
                    handleClearSearch={handleClearSearch}
                />*/}

                {loading ? (
                    <Box display="flex" justifyContent="center" py={4}>
                        <CircularProgress />
                    </Box>
                ) : error ? (
                    <Typography color="error">
                        {error}
                    </Typography>
                ) : users.length > 0 ? (
                    <List sx={{ maxHeight: 400, overflow: 'auto' }}>
                        {users.map((user) => (
                            <ListItemButton
                                key={user.user_id}
                                onClick={() => onSelectUser(user)}
                            >
                                <ListItemText
                                    primary={[user.last_name, user.first_name].filter(Boolean).join(' ')}
                                    secondary={
                                        <>
                                            {user.email}
                                            {user.phone_number && ` / ${user.phone_number}`}
                                        </>
                                    }
                                />
                            </ListItemButton>
                        ))}
                    </List>
                ) : (
                    <Typography>
                        担当者が見つかりません。
                    </Typography>
                )}

                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                />
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={onClose}
                    variant="outlined"
                >
                    閉じる
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default UserModal;